export function PromiseAll(promises) {
  let finishedCount = 0
  let progressCb = () => {}
  const promisesLength = promises.length
  const results = new Array(promisesLength)
  const result = new Promise(function(resolve, reject) {
    promises.forEach((val, idx) => {
      Promise.resolve(val).then(
        function(res) {
          finishedCount++
          results[idx] = res
          progressCb(finishedCount, results)
          if (finishedCount === promisesLength) {
            return resolve(results)
          }
        },
        function(err) {
          return reject(err)
        },
      )
    })
  })
  result.progress = cb => {
    progressCb = cb
    return result
  }
  return result
}
